// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/site.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { PlanType } from "../../enum/v1/plan_type_pb.js";
import { BillingSubscription } from "./billing_subscription_pb.js";
import { BillingPrice } from "./billing_price_pb.js";
import { BillingProduct } from "./billing_product_pb.js";
import { SiteStatus } from "../../enum/v1/site_status_pb.js";
import { SitePurpose } from "../../enum/v1/site_purpose_pb.js";
import { SiteMembership } from "./site_membership_pb.js";
import { Media } from "./media_pb.js";
import { SocialIcon } from "./social_icon_pb.js";

/**
 * @generated from message fingertip.common.type.v1.Site
 */
export const Site = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.Site",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "created_at", kind: "message", T: Timestamp },
    { no: 5, name: "updated_at", kind: "message", T: Timestamp },
    { no: 8, name: "override_plan", kind: "enum", T: proto3.getEnumType(PlanType) },
    { no: 9, name: "subscription", kind: "message", T: BillingSubscription },
    { no: 10, name: "price", kind: "message", T: BillingPrice },
    { no: 11, name: "product", kind: "message", T: BillingProduct },
    { no: 12, name: "plan", kind: "enum", T: proto3.getEnumType(PlanType) },
    { no: 13, name: "status", kind: "enum", T: proto3.getEnumType(SiteStatus) },
    { no: 16, name: "location_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "business_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "is_white_labeled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 21, name: "google_analytics_tracking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "facebook_pixel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "favicon_bucket", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "onboarding_google_place_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 29, name: "home_page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "conversion_metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "selected_site_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 32, name: "time_zone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 35, name: "onboarding_step", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 39, name: "ip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 40, name: "ip_country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "ip_region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 42, name: "ip_city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 43, name: "ip_continent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 44, name: "ip_postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 45, name: "ip_metro_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 46, name: "ip_is_eu_country", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 47, name: "ip_region_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 48, name: "ip_latitude", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 49, name: "ip_longitude", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 50, name: "ip_timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 51, name: "site_template_tag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 52, name: "verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 53, name: "purpose", kind: "enum", T: proto3.getEnumType(SitePurpose) },
    { no: 54, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 55, name: "google_tag_manager_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 56, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 57, name: "workspace_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 58, name: "sensitive_content", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 59, name: "membership", kind: "message", T: SiteMembership },
    { no: 61, name: "custom_html_body_start", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 62, name: "custom_html_body_end", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 64, name: "google_site_verification", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 67, name: "migrated_at", kind: "message", T: Timestamp },
    { no: 68, name: "logo_media", kind: "message", T: Media },
    { no: 69, name: "social_icons", kind: "message", T: SocialIcon, repeated: true },
    { no: 70, name: "password_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 71, name: "original_plan", kind: "enum", T: proto3.getEnumType(PlanType) },
    { no: 72, name: "default_locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 73, name: "site_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

